export const datathirdchallenge = [
    {
      question: " تعرف لو غسلت أسنانك بعنف وقوة إيه اللي هيحصل؟",
      option1: " الأسنان تبقى أقوى",
      option2: "تجرح اللثة وتضعف مينا الأسنان",
      option3: "  تزود لمعان الأسنان",
      option4: "تزود المناعة",
      ans: 2,
    },
    {
      question: "تعرف لما تهمل تغيير فرشة  أسنانك لأكتر من 3 شهور إيه اللي هيحصل؟",
      option1:  " مش هيحصل حاجة",
      option2: " تحمي الأسنان من الجير ",
      option3:  "تقوية الأسنان ",
      option4 : "تقل فعالية غسيل الأسنان وتأثر على اللثة",
      ans: 4,
    },
    {
      question: " تعرف لو غسلت أسنانك بعد شرب المياه الغازية مباشرة إيه اللي هيحصل؟ ",
      option1:  "هيقل تأثير المياه الغازية على الأسنان ",
      option2: " هيحصل خدوش وضعف في الأسنان ",
      option3: "مش هيحصل حاجة ",
      option4: "هتبقى أكثر لمعانًا",
      ans: 2,
    },
    {
      question: "تعرف أيه من العادات دي يعتبر عادة صحيحة؟",
      option1: " أكل الحلوى قبل النوم بدون غسل الأسنان",
      option2: " استخدام خيط الأسنان مع الفرشاة",
      option3:"  كسر البندق بالأسنان",
      option4 : " شرب مشروبات غازية يوميًا",
      ans: 2,
    },
    {
      question: " تعرف  لما تاكل أكل لزج (زي الكراميل) وما تنظفش أسنانك بعدها، ده ممكن يسبب",
      option1: "  تقوية الأسنان",
      option2: " تآكل مينا الأسنان وتسوسها",
      option3: "إنعاش الفم",
      option4 : "منع التسوس",
      ans: 2,
    },
    
  ];